
export * from './network'
export * from './tokens'

export const ROUTER_STATS_HOST="https://api.stats.routerprotocol.com"
export const NETWORK_CONFIG_URL="https://raw.githubusercontent.com/router-protocol/sdk-network-config/main/networkConfig/mainnet.json"